import script from "./TasksBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TasksBoard.vue?vue&type=script&setup=true&lang=ts"

import "./TasksBoard.vue?vue&type=style&index=0&id=93ebad2a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93ebad2a"]])

export default __exports__